/**
 * The ⓘ on the "Doesn't add up" chip and page: three steps, each with a
 * marked-up picture of the real screen (client/public/how-to/doesnt-add-up-*).
 */
import type { InfoTopic } from "@/components/info-button";

export const MISMATCH_HELP: InfoTopic = {
    title: "How this list works",
    lines: [
        "Every night at 5 AM, GWC checks its records against each other. When two disagree, you get one row.",
        "1. Read the sentence. The two chips under it are the records that disagree. Tap a chip to open that record.",
        "2. Press the one button. It does what the button on the job or invoice page does. You have 24 hours to Undo.",
        "3. If it's really fine, press “Not a problem, hide” and pick why. It comes back only if something on it changes.",
        "The chip on the toolbar counts only your rows. Nothing rings and nothing goes to your phone.",
    ],
    shots: [
        {
            src: "/how-to/doesnt-add-up-row.png",
            alt: "One row on the Doesn't add up list",
            marks: [
                { x: 6, y: 18, label: "What doesn't add up, in plain words", side: "below" },
                { x: 30, y: 72, label: "These two records don't match", side: "right" },
                { x: 82, y: 50, label: "This fixes it", side: "left" },
                { x: 85, y: 82, label: "Not a problem? Hide it and pick why", side: "left" },
            ],
        },
    ],
};
